export default __webpack_public_path__ + "static/media/Ptt.0f43f211.png";